import {
  FC,
  createContext,
  PropsWithChildren,
  useContext,
  useMemo
} from 'react'

import usePopup, { PopupReturnType } from 'hooks/usePopup'
import { initialPopup } from '../../../hooks/constants'

type ContextProps = {
  deleteAdditionalValuesPopup: PopupReturnType
  addEditAdditionalValuesPopup: PopupReturnType
}

const basePopup = (title: string) => ({
  title
})

const AdditionalValuesPopupContext = createContext<ContextProps>({
  deleteAdditionalValuesPopup: initialPopup,
  addEditAdditionalValuesPopup: initialPopup
})

const AdditionalValuesPopupProvider: FC<PropsWithChildren> = ({ children }) => {
  const deleteAdditionalValuesPopupProps = usePopup(
    basePopup('Delete additional value?')
  )

  const addEditAdditionalValuesPopupProps = usePopup(
    basePopup(' additional value')
  )

  const context = useMemo(
    () => ({
      deleteAdditionalValuesPopup: deleteAdditionalValuesPopupProps,
      addEditAdditionalValuesPopup: addEditAdditionalValuesPopupProps
    }),
    [deleteAdditionalValuesPopupProps, addEditAdditionalValuesPopupProps]
  )

  return (
    <AdditionalValuesPopupContext.Provider value={context}>
      {children}
    </AdditionalValuesPopupContext.Provider>
  )
}

export const useAdditionalValuesPopup = () =>
  useContext(AdditionalValuesPopupContext)

export default AdditionalValuesPopupProvider
